'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeModal = exports.stopScrollMobile = exports.setLastY = exports.stopScroll = exports.scrollToTop = exports.scrollTo = undefined;

var _isomorphicHelpers = require('./isomorphic-helpers');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Scrolls to given "elementTo", scroll is applied on "scrollContainer"
 * @param elementTo
 * @param scrollContainer
 * @param duration
 * @param getFullOffset if true, offsetTop is being calculated up to html, not only up to "elementTo" parent
 * @param additionalOffset this is a value that is being added to final scroll position
 */
var scrollTo = exports.scrollTo = function scrollTo(elementTo, scrollContainer, duration) {
  var getFullOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var additionalOffset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

  if (!(0, _isomorphicHelpers.isServerSide)()) {
    var scrollElem = elementTo;
    var elementTop = 0;

    if (getFullOffset) {

      while (scrollElem) {
        elementTop += scrollElem.offsetTop;
        scrollElem = scrollElem.offsetParent;
      }
    } else {
      elementTop = elementTo.offsetTop;
    }

    elementTop += additionalOffset;

    var scroll = function scroll(container) {
      var starting = container.scrollTop;
      var diff = elementTop - starting;
      var start = void 0;

      window.requestAnimationFrame(function step(timestamp) {
        if (!start) {
          start = timestamp;
        }
        var time = timestamp - start;
        var percent = Math.min(time / duration, 1);
        container.scrollTop = starting + diff * percent;
        if (time < duration) {
          window.requestAnimationFrame(step);
        }
      });
    };

    if (Array.isArray(scrollContainer)) {
      scrollContainer.forEach(scroll);
    } else {
      scroll(scrollContainer);
    }
  }
};

/**
 * Scrolls to the top of the window. By default the scroll isn't animated, that
 * is it scrolls instantly to the top.
 * @param {boolean} animated Uses smooth scrolling if true. Defaults to false.
 */
var scrollToTop = exports.scrollToTop = function scrollToTop(animated) {
  if (!(0, _isomorphicHelpers.isServerSide)()) {
    window.scroll({
      top: 0,
      behavior: animated && 'smooth' || 'auto'
    });
  }
};

var isDescendant = function isDescendant(parent, target) {
  if (parent === target) {
    return true;
  } else if (!parent.children || !parent.children.length) {
    return false;
  } else {
    var found = false;
    [].concat(_toConsumableArray(parent.children)).map(function (child) {
      found = found || isDescendant(child, target);
    });
    return found;
  }
};

var limitTopAndBottomScroll = function limitTopAndBottomScroll(scrollableElement) {
  // If the modal is scrolled all the way to the bottom, and we try and scroll further, prevent.
  if (scrollableElement.scrollTop === 0 && event.deltaY <= 0) {
    event.preventDefault();
    event.stopPropagation();
    return;
  }

  // If the modal is scrolled all the way to the top, and we try and scroll further, prevent.
  if (scrollableElement.scrollHeight - (Math.round(scrollableElement.scrollTop) + scrollableElement.clientHeight) <= 1 && event.deltaY > 0) {
    event.preventDefault();
    event.stopPropagation();
    return;
  }
};

var stopScroll = exports.stopScroll = function stopScroll(modalContainerClassName, overlay, scrollableClassName) {
  return function (event) {
    if (!(0, _isomorphicHelpers.isServerSide)()) {
      // If the origin of the scroll event is the overlay, prevent scrolling.
      if (scrollableClassName) {
        var scrollableElements = document.getElementsByClassName(scrollableClassName);
        var isScrollable = false;
        [].concat(_toConsumableArray(scrollableElements)).map(function (element) {
          isScrollable = isScrollable || isDescendant(element, event.target);
        });
        if (isScrollable) {
          [].concat(_toConsumableArray(scrollableElements)).map(function (element) {
            limitTopAndBottomScroll(element);
          });
          return;
        }
      }
      if (event.target === overlay) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      // Find the modal container.
      var modalContainer = document.getElementsByClassName(modalContainerClassName)[0];

      limitTopAndBottomScroll(modalContainer);

      // It should be pretty obvious what this does, making this comment wholly redundant
      var modalContainerBCR = modalContainer.getBoundingClientRect();

      // Catch when the modal does not have a scroll.
      if (modalContainer.scrollTop === 0 && modalContainer.scrollHeight <= modalContainer.clientHeight && modalContainer.clientHeight - modalContainerBCR.height < 1) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
    }
  };
};

//lastY is a global variable to be used defined by listener for mobile and is used in stopScrollMobile.
var lastY = void 0;
var setLastY = exports.setLastY = function setLastY(event) {
  lastY = event.touches[0].pageY;
};

var limitMobilescroll = function limitMobilescroll(scrollableElement) {
  event.stopPropagation();
  event.preventDefault();
  if (event.touches[0].pageY > lastY) {
    scrollableElement.scrollTop -= event.touches[0].pageY - lastY;
    lastY = event.touches[0].pageY;
  }
  if (event.touches[0].pageY < lastY) {
    scrollableElement.scrollTop += lastY - event.touches[0].pageY;
    lastY = event.touches[0].pageY;
  }
};

var stopScrollMobile = exports.stopScrollMobile = function stopScrollMobile(mobileContainerClassName, scrollableClassName) {
  return function (event) {
    if (scrollableClassName) {
      var scrollableElements = document.getElementsByClassName(scrollableClassName);
      var isScrollable = false;
      [].concat(_toConsumableArray(scrollableElements)).map(function (element) {
        isScrollable = isScrollable || isDescendant(element, event.target);
      });
      if (isScrollable) {
        [].concat(_toConsumableArray(scrollableElements)).map(function (element) {
          limitMobilescroll(element);
        });
        return;
      }
    }
    var mobileContainer = document.getElementsByClassName(mobileContainerClassName)[0];
    limitMobilescroll(mobileContainer);
  };
};

var closeModal = exports.closeModal = function closeModal(props, overlay) {
  if (overlay) {
    overlay.removeEventListener('wheel', stopScroll, true);
    overlay.removeEventListener('touchmove', stopScrollMobile, true);
    overlay.removeEventListener('touchstart', setLastY, true);
  }
  props.closeModal();
};